import type { PriceValue } from '@elfsight/configurator-contracts';
import { MODELS_WITH_PAYMENT } from '../constants';

export const doesPriceSupportPayment = (price?: PriceValue) => {
  if (!price) {
    return false;
  }

  return MODELS_WITH_PAYMENT.some((model) => model === price.pricingModel);
};
